import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
// Your existing code...
import { FiX } from "react-icons/fi";


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color:#2B3497

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
    width:177px;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
  cursor:pointer; 
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin-bottom: 5px;
  font-weight: 600;
  &::after {
    content: '*';
    color: red;
    margin-left: 5px;
  }
`;

const Asterisk = styled.span`
  color: red;
`;
const FormItem = styled.div`
  flex: 1 1 auto; /* Flex-grow, flex-shrink, and minimum width */
`;
const Dropdown = styled.select`
  font-size: 15px !important;
  width:164px;
  border: none;
  border-bottom: 2px solid #3d46b4;
  padding: 10px;
  background: transparent;
  font-family: 'Segoe UI', Regular;
  outline: none; /* Remove default focus outline */
  margin-right: 20px; // Space to the right of the dropdown
  flex: 1; // Makes the dropdown take up more space
`;
const Input = styled.input`
  width:55%;
  border: none;
  border-bottom: 2px solid #3d46b4;
  background: transparent;
  padding: 10px;
  font-size: 16px;
  outline: none;
  flex: 1;
    margin-right: 20px; // Space to the right of the dropdown

`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
   background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;



const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;



const AddBuildingPage = () => {
  const [showInput, setShowInput] = useState(false);
  const [locationName, setLocationName] = useState('');
  const [locationsGet, setLocationsGet] = useState([]);
  const [gateGet, setGateGet] = useState([]);

  const [locations, setLocations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [locationsGetUpdate, setLocationsGetUpdate] = useState([]);
  const [gateGetUpdate, setGateGetUpdate] = useState([]);

  const rowsPerPage = 7;
  const [formValues, setFormValues] = useState({
    locationGet: '',
  });
  const [formValuesUpdate, setFormValuesUpdate] = useState({
    gateGetUpdate: '',
    locationGetUpdate: '',
  });
  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    // Ensure value is compared as the same type as location.id
    const selectedLocation = locationsGet.find((location) => location.id === parseInt(value, 10));

    console.log("Selected Location Object:", selectedLocation);

    // if (selectedLocation) {
    //   try {
    //     const menuNameResponse = await axios.get(`/Location/GetBuildingsByLocation?locationID=${selectedLocation.id}`);
    //     console.log("menuNameResponse", menuNameResponse);
    //     setGateGet(menuNameResponse.data);
    //   } catch (error) {
    //     if (error.response && error.response.status === 404) {
    //       toast.error("No gates found for the provided location.");
    //     } else {
    //       toast.error("An error occurred while fetching gates.");
    //     }
    //   }
    // }

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleInputChangeNew = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleInputChangeNewUpdate = (e) => {
    const { name, value } = e.target;
    setFormValuesUpdate((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get('/Location/GetAllBuildings');
        console.log("response.data", response.data);

        if (response.data) {
          // Assuming the API returns an array of locations
          setLocations(response.data);
          setShowPagination(true); // Show pagination after submitting at least one row

        } else {
          setLocations([]); // Ensure locations is always an array
        }
      } catch (error) {
        console.error('Error fetching locations:', error);
        setLocations([]); // Ensure locations is always an array even if the request fails
      }
      try {
        const locationNameResponse = await axios.get('/location');
        setLocationsGet(locationNameResponse.data)
        setLocationsGetUpdate(locationNameResponse.data)



      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };

    fetchLocations();
  }, []);



  const handleAddLocationClick = () => {
    setIsPopupVisibleCreate(true);
  };

  const handleLocationSubmit = async () => {
    // Validate input fields
    if (locationName.trim() === '') {
      toast.error('Area name cannot be empty');
      return;
    }

    if (!formValues.locationGet || formValues.locationGet === '') {
      toast.error('Please select a location');
      return;
    }

    // if (!formValues.gateGet || formValues.gateGet === '') {
    //   toast.error('Please select a gate');
    //   return;
    // }

    // Retrieve the full location object and gate object from the dropdowns
    const selectedLocation = locationsGet.find((location) => location.id === parseInt(formValues.locationGet, 10));
    // const selectedGate = gateGet.find((gate) => gate.name === formValues.gateGet);

    // Additional validation to ensure selected location and gate are valid
    if (!selectedLocation) {
      toast.error('Invalid location selected');
      return;
    }

    // if (!selectedGate) {
    //   toast.error('Invalid gate selected');
    //   return;
    // }

    // Prepare request data in the format you want
    const requestData = {
      id: 0,
      name: locationName,
      // gateID: selectedGate.id, // Assuming 'gate' has an id field
      gateID: null, // Assuming 'gate' has an id field

      // gate: selectedGate.name, // Set to the selected gate's name
      gate: null, // Set to the selected gate's name
      locationID: selectedLocation.id, // Use selected location id
      location: selectedLocation.locationName,
      isActive: true,
      createdBy: "string",
      modifiedBy: "string",
      createdOn: new Date().toISOString(), // current date and time
      modifiedOn: new Date().toISOString(),
    };

    try {
      const response = await axios.post('/Location/InsertBuilding', requestData);
      if (response.status === 200) {
        if (response.data == "Building already Exists..") {
          toast.error('Area already Exists..');
          handleReset();
          return

        }
        toast.success('Area added successfully');
        handleReset();

        const fetchLocations = async () => {
          try {
            const response = await axios.get('/Location/GetAllBuildings');
            console.log("response.data", response.data);

            if (response.data) {
              // Assuming the API returns an array of locations
              setLocations(response.data);
              setShowPagination(true); // Show pagination after submitting at least one row

            } else {
              setLocations([]); // Ensure locations is always an array
            }
          } catch (error) {
            console.error('Error fetching locations:', error);
            setLocations([]); // Ensure locations is always an array even if the request fails
          }
          try {
            const locationNameResponse = await axios.get('/location');
            setLocationsGet(locationNameResponse.data)
            setLocationsGetUpdate(locationNameResponse.data)



          } catch (error) {
            console.error('Error fetching dropdown data:', error);
          }
        };

        fetchLocations();

        // Clear input fields and close the form
        setLocationName('');
        setFormValues({ locationGet: '' });
        setIsPopupVisibleCreate(false); // Close the input field
      } else {
        toast.error('Unexpected response from the server');
      }
    } catch (error) {
      console.error('Error adding location:', error);
      toast.error('Error adding Area');
    }
  };
  const handleDelete = (id) => {
    confirmAlert({
      title: <span style={{ color: '#dc3545' }}>Warning</span>,
      message: 'Are you sure you want to delete this Area?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              // Sending the PUT request to mark the location as deleted
              await axios.put('/Location/UpdateBuilding', {
                id: id,
                locationName: locations.find(location => location.id === id)?.locationName,
                isDeleted: true
              });

              // Update the local state to remove the deleted location from the UI
              setLocations((prevData) => prevData.filter(location => location.id !== id));

              // Show success toast message
              toast.success('Area Deleted Successfully');
            } catch (error) {
              console.error('Error deleting location:', error);
              // Show error toast message
              toast.error('Failed to Delete Location');
            }
          }
        },
        {
          label: 'No',
          onClick: () => {
            // Close dialog without action
          }
        }
      ]
    });
  };

  const handleReset = () => {
    setSearchTerm('');
    setLocationName('');
    setFormValues({
      locationGet: '',
    });
    setCurrentPage(1); // Reset pagination to the first page

  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);

    setCurrentPage(1); // Reset to first page when searching
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

   const filteredLocations = locations.filter((location) => {
  const search = searchTerm?.toLowerCase() ?? '';

  return (
    (location.location?.toLowerCase().includes(search)) ||
    (location.gate?.toLowerCase().includes(search)) ||
    (location.name?.toLowerCase().includes(search))
  );
});


  // Pagination logic
  const itemsPerPage = 7;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLocations.slice(indexOfFirstItem, indexOfLastItem);




  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = Math.ceil(filteredLocations.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredLocations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };


  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(locations, column, direction);
    setLocations(sortedData);
  };
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isPopupVisibleCreate, setIsPopupVisibleCreate] = useState(false);

  const [popupData, setPopupData] = useState('');



  const handleEdit = async (location) => {
    console.log("get row data", location);
    setLocationNameUpdate(location.name)

    setFormValuesUpdate({
      locationGetUpdate: location.locationID || "", // Ensure fallback to empty string
      gateGetUpdate: location.gateID || "" // Ensure fallback for gate value
    });
    // try {
    //   const menuNameResponse = await axios.get(`/Location/GetBuildingsByLocation?locationID=${location.locationID}`);
    //   console.log("menuNameResponse", menuNameResponse);
    //   setGateGetUpdate(menuNameResponse.data);
    // } catch (error) {
    //   if (error.response && error.response.status === 404) {
    //     toast.error("No gates found for the provided location.");
    //   } else {
    //     toast.error("An error occurred while fetching gates.");
    //   }
    // }

    setPopupData(location);
    setIsPopupVisible(true);
  };

  const [locationNameUpdate, setLocationNameUpdate] = useState('');

  const closePopup = () => {
    setLocationNameUpdate('');
    setFormValuesUpdate({ gateGetUpdate: '', locationGetUpdate: '' });

    setIsPopupVisible(false);

  };
  const handleInputChangeUpdate = async (e) => {
    const { name, value } = e.target;

    // Ensure value is compared as the same type as location.id
    const selectedLocation = locationsGetUpdate.find((location) => location.id === parseInt(value, 10));

    console.log("Selected Location Object:", selectedLocation);

    // if (selectedLocation) {
    //   try {
    //     const menuNameResponse = await axios.get(`/Location/GetBuildingsByLocation?locationID=${selectedLocation.id}`);
    //     console.log("menuNameResponse", menuNameResponse);
    //     setGateGetUpdate(menuNameResponse.data);
    //   } catch (error) {
    //     if (error.response && error.response.status === 404) {
    //       toast.error("No gates found for the provided location.");
    //     } else {
    //       toast.error("An error occurred while fetching gates.");
    //     }
    //   }
    // }

    setFormValuesUpdate((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleLocationSubmitUpdate = async () => {
    // Validate input fields
    if (locationNameUpdate.trim() === '') {
      toast.error('Area name cannot be empty');
      return;
    }


    if (!formValuesUpdate.locationGetUpdate || formValues.locationGetUpdate === '') {


      toast.error('Please select a location');
      return;
    }

    // if (!formValuesUpdate.gateGetUpdate || formValuesUpdate.gateGetUpdate === '') {
    //   toast.error('Please select a gate');
    //   return;
    // }

    // Retrieve the full location object and gate object from the dropdowns
    const selectedLocation = locationsGetUpdate.find((location) => location.id === parseInt(formValuesUpdate.locationGetUpdate, 10));
    // const selectedGate = gateGetUpdate.find((gate) => gate.id === formValuesUpdate.gateGetUpdate);
    // console.log("gateGetUpdate", gateGetUpdate);


    // console.log("selectedGate", formValuesUpdate.gateGetUpdate);

    // console.log("selectedGate", selectedGate);

    // Additional validation to ensure selected location and gate are valid
    if (!selectedLocation) {
      toast.error('Invalid location selected');
      return;
    }

    // if (!selectedGate) {
    //   toast.error('Invalid gate selected');
    //   return;
    // }

    // Prepare request data in the format you want
    const requestData = {
      id: popupData.id,
      name: locationNameUpdate,
      // gateID: selectedGate.id, // Assuming 'gate' has an id field
      gateID: null, // Assuming 'gate' has an id field
      // gate: selectedGate.name, // Set to the selected gate's name
      gate: null, // Set to the selected gate's name
      locationID: selectedLocation.id, // Use selected location id
      location: selectedLocation.locationName,
      isActive: true,
      createdBy: "string",
      modifiedBy: "string",
      createdOn: new Date().toISOString(), // current date and time
      modifiedOn: new Date().toISOString(),
    };

    try {
      const response = await axios.put('/Location/UpdateBuilding', requestData);
      if (response.status === 200) {
        toast.success('Area updated successfully');

        handleReset();

        // Fetch the updated list of locations after successful submission
        try {
          const response = await axios.get('/Location/GetAllBuildings');
          console.log("response.data", response.data);

          if (response.data) {
            // Assuming the API returns an array of locations
            setLocations(response.data);
            setShowPagination(true); // Show pagination after submitting at least one row

          } else {
            setLocations([]); // Ensure locations is always an array
          }
        } catch (error) {
          console.error('Error fetching locations:', error);
          setLocations([]); // Ensure locations is always an array even if the request fails
        }
        try {
          const locationNameResponse = await axios.get('/location');
          setLocationsGet(locationNameResponse.data)
          setLocationsGetUpdate(locationNameResponse.data)



        } catch (error) {
          console.error('Error fetching dropdown data:', error);
        }


        // Clear input fields and close the form
        setLocationNameUpdate('');
        setFormValuesUpdate({ locationGet: '' });
        closePopup()// Close the input field
      } else {
        toast.error('Unexpected response from the server');
      }
    } catch (error) {
      console.error('Error adding location:', error);
      toast.error('Error adding location');
    }
  };


  return (
    <Container>
      <Header>
        <Heading>Add Area</Heading>
        <SearchBox>
          <SearchIcon size={20} />
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </SearchBox>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <Button className="add-location" onClick={handleAddLocationClick}>
            Add Area<FiPlus size={20} />
          </Button>
          {/* {showInput && (
            <>
              <FormItem>
                <Label>
                  Select Location<Asterisk>*</Asterisk>
                </Label>
                <Dropdown
                  name="locationGet"
                  value={formValues.locationGet}
                  onChange={handleInputChange}
                  style={{ fontSize: "12px" }}

                >
                  <option value="">Select Location</option>
                  {locationsGet.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.locationName}
                    </option>
                  ))}
                </Dropdown>
              </FormItem>
              <FormItem>
                <Label>
                  Select Gate<Asterisk>*</Asterisk>
                </Label>
                <Dropdown
                  name="gateGet"
                  value={formValues.gateGet}
                  onChange={handleInputChangeNew}
                  style={{ fontSize: "12px" }}

                >
                  <option value="">Select Gate</option>
                  {gateGet.map((gate) => (
                    <option key={gate.id} value={gate.name}>
                      {gate.name}
                    </option>
                  ))}
                </Dropdown>
              </FormItem>
              <FormItem>
                <Label>Area Name<Asterisk>*</Asterisk></Label>
                <Input
                  name="gate" // Added the name attribute here
                  type="text"
                  placeholder="Enter Area Name"
                  value={locationName}
                  onChange={(e) => setLocationName(e.target.value)}
                />

              </FormItem>
            </>
          )} */}
        </div>
        {/* <ButtonGroup>
          <Button className="reset" onClick={handleReset}>
            Reset
          </Button>
          <Button className="submit" onClick={handleLocationSubmit}>
            Submit
          </Button>
        </ButtonGroup> */}
      </Card>
      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <TableHeader colSpan={'3'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Area Details</span>
                  <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                    {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                  </IconWrapper>
                </div>
              </TableHeader>

            </tr>
          </thead>
          {isExpanded && (
            <>
              <thead>
                <tr>
                  <TableHeader onClick={() => handleSort('location')}>Location Name {sortColumn === 'location' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  {/* <TableHeader onClick={() => handleSort('gate')}>Gate  Name {sortColumn === 'gate' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader> */}
                  <TableHeader onClick={() => handleSort('name')}>Area Name {sortColumn === 'name' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader>Actions</TableHeader>

                </tr>
              </thead>
              <tbody>
                {currentRows.map((location, index) => (
                  <TableRow key={index}>
                    <TableCell>{location.location}</TableCell>
                    {/* <TableCell>{location.gate}</TableCell> */}
                    <TableCell>{location.name}</TableCell>
                    <TableCell>
                      <IconWrapper onClick={() => handleEdit(location)}>
                        <FiEdit />
                      </IconWrapper>
                      <IconWrapper onClick={() => handleDelete(location.id)}>
                        <FiTrash2 />
                      </IconWrapper>
                    </TableCell>
                  </TableRow>
                ))}
              </tbody>
            </>)}
        </StyledTable>
        {isExpanded && (
          <>
            <PaginationContainer>
              <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </PaginationButton>

              <DropdownSelect value={currentPage} onChange={handlePageChange}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Page {i + 1}
                  </option>
                ))}
              </DropdownSelect>

              <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </>)}
        {isPopupVisibleCreate && (
          <Popup>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#293495' }}>Add Area
              </h3>
              <FiX
                style={{ cursor: 'pointer' }}
                size={20}
                onClick={() => setIsPopupVisibleCreate(false)}
              />
            </div>
            <LabelValueContainer>
              <Label>Select Location:</Label>
              <Value>
                <Dropdown
                  name="locationGet"
                  value={formValues.locationGet}
                  onChange={handleInputChange}
                  style={{ fontSize: "12px" ,width: '171px'}}

                >
                  <option value="">Select Location</option>
                  {locationsGet.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.locationName}
                    </option>
                  ))}
                </Dropdown>
              </Value>
            </LabelValueContainer>
            {/* <LabelValueContainer>
              <Label> Select Gate:</Label>
              <Value>
                <Dropdown
                  name="gateGet"
                  value={formValues.gateGet}
                  onChange={handleInputChangeNew}
                  style={{ fontSize: "12px",width: '171px' }}

                >
                  <option value="">Select Gate</option>
                  {gateGet.map((gate) => (
                    <option key={gate.id} value={gate.name}>
                      {gate.name}
                    </option>
                  ))}
                </Dropdown>
              </Value>
            </LabelValueContainer> */}
            <LabelValueContainer>
              <Label>Area:</Label>
              <Value>
                <Input
                  name="gate" // Added the name attribute here
                  type="text"
                  placeholder="Enter Area Name"
                  value={locationName}
                  onChange={(e) => setLocationName(e.target.value)}
                />
              </Value>
            </LabelValueContainer>

            <ButtonContainer>
              <PopupButton onClick={handleReset} style={{ backgroundColor: 'red' }}>Reset</PopupButton>
              <PopupButton onClick={handleLocationSubmit}>Submit</PopupButton>
            </ButtonContainer>
            {/* Show loader when loading */}
          </Popup>
        )}

        {isPopupVisible && (
          <Popup>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#293495' }}>Update Area</h3>
              <FiX
                style={{ cursor: 'pointer' }}
                size={20}
                onClick={() => setIsPopupVisible(false)}
              />
            </div>
            <LabelValueContainer>
              <Label>Select Location:</Label>
              <Value>
                <Dropdown
                  name="locationGetUpdate"
                  value={formValuesUpdate.locationGetUpdate}
                  onChange={handleInputChangeUpdate}
                  style={{ fontSize: "12px",width: '171px' }}

                >
                  <option value="" disabled>
                    {popupData.location || "Select Location"}
                  </option>
                  {locationsGetUpdate.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.locationName}
                    </option>
                  ))}
                </Dropdown>
              </Value>
            </LabelValueContainer>
            {/* <LabelValueContainer>
              <Label>Select Gate:</Label>
              <Value>
                <Dropdown
                  name="gateGetUpdate"
                  value={formValuesUpdate.gateGetUpdate}
                  onChange={handleInputChangeNewUpdate}
                  style={{ fontSize: "12px",width: '171px' }}

                >
                  <option value="" disabled>
                    {popupData.gate || "Select Gate"}
                  </option>
                  {gateGetUpdate.map((gate) => (
                    <option key={gate.id} value={gate.name}>
                      {gate.name}
                    </option>
                  ))}
                </Dropdown>
              </Value>
            </LabelValueContainer> */}
            <LabelValueContainer>
              <Label>Area:</Label>
              <Value>
                <Input
                  name="gate" // Added the name attribute here
                  type="text"
                  placeholder="Enter Area Name"
                  value={locationNameUpdate}
                  onChange={(e) => setLocationNameUpdate(e.target.value)}
                />
              </Value>
            </LabelValueContainer>

            <ButtonContainer>
              <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
              <PopupButton onClick={handleLocationSubmitUpdate}>Update</PopupButton>
            </ButtonContainer>
            {/* Show loader when loading */}
          </Popup>
        )}
      </TableContainer>
      <ToastContainer />

    </Container>
  );
};

export default AddBuildingPage;
